<template>
  <a-list :data-source="cloudregions" class="cloudregion-setup-list" :key="updated">
    <a-list-item slot="renderItem" slot-scope="cloudregion" class="cloudregion-setup-list-item" :class="{ active: selected === cloudregion.id }">
      <a-row :key="cloudregion.id" justify="center" style="width: 207px;">
        <a-col :span="18">
          <a @click="showSetupView(cloudregion)">{{ formatRegionName(cloudregion.name) }}</a>
          <div>{{ cloudregion.provider }}</div>
        </a-col>
        <a-col :span="6">
          <a-tooltip>
            <template slot="title">
              {{ cloudregion.setup.desc }}
            </template>
            <a-icon @click="showSetupView(cloudregion)" :type="cloudregion.setup.icon" :style="{ fontSize: '32px', color: cloudregion.setup.color }" :spin="cloudregion.setup.spin" />
          </a-tooltip>
        </a-col>
      </a-row>
    </a-list-item>
  </a-list>
</template>

<script>
export default {
  name: 'RegionSetupList',
  props: {
    cloudregions: {
      type: Array,
      default: () => ([]),
      required: true,
    },
  },
  data () {
    return {
      updated: 0,
      selected: '',
    }
  },
  watch: {
    cloudregions () {
      this.updated += 1
    },
  },
  methods: {
    formatRegionName (name) {
      if (!name) return '-'
      const segs = name.split(' ')
      if (segs.length > 1) {
        return segs.slice(1).join(' ')
      }
      return name
    },
    showSummaryView (cloudregion) {
      this.changeView('RegionSetupSummary', cloudregion)
    },
    showSetupView (cloudregion) {
      this.changeView('RegionSetup', cloudregion)
    },
    changeView (viewName, viewData) {
      this.selected = viewData ? viewData.id : ''
      this.$emit('changeView', { name: viewName, data: viewData || {} })
    },
  },
}
</script>

<style lang="less" scoped>
@import "~@/styles/less/theme";

.cloudregion-setup-list {
  border-right: 1px solid #e8e8e8;
  height: inherit;
  overflow: auto;

  .cloudregion-setup-list-item {
    padding-left: 8px;

    &:hover {
      background-color: rgb(230, 247, 255);
    }

    &.active {
      border-left: 2px solid @text-color-secondary;
      background-color: rgb(230, 247, 255);
    }
  }
}
</style>
